import { Components, Theme } from '@mui/material';

const MuiTableSortLabel: Components<Theme>['MuiTableSortLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-active': {
        color: theme.palette.text.disabled,
      },
    }),
  },
};

export default MuiTableSortLabel;
